import React, { useState } from "react";
 
import Form from "react-bootstrap/Form";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import FormHelperText from "@mui/material/FormHelperText"; 

import { cidades_estados } from "../../assets/data/estados-cidades";
import { porteData } from "../../assets/data/porte";

import { postRegisterWithOrg } from "../../services/cadastro";

const CadastroComOrg = ({ setIsFetching }) => {
	const [nome_usuario, setNome] = useState("");
	const [nome_organizacao, setOrganizacao] = useState("");
	const [cargo, setCargo] = useState("");
	const [cidade, setCidade] = useState("");
	const [estado, setEstado] = useState("");
	const [porte, setPorte] = useState("");
	const [email, setEmail] = useState("");
	const [senha, setSenha] = useState("");
	const [confirmarSenha, setConfirmarSenha] = useState("");
	const [anoFundacao, setAnoFundacao] = useState("");

	const [error, setError] = useState({
		nome_usuario: false,
		cargo: false,
		email: false,
		senha: false,
		confirmarSenha: false,
		nome_organizacao: false,
		cidade: false,
		estado: false,
		porte: false,
		anoFundacao: false,
	});

	const [helperText, setHelperText] = useState({
		nome_usuario: "",
		cargo: "",
		email: "",
		senha: "Escreva uma senha com pelo menos 8 caracteres",
		nome_organizacao: "",
		cidade: "",
		estado: "",
		porte: "",
		anoFundacao: "",
	});

	const selecionarCidades = () => {
		for (let item in cidades_estados) {
			if (
				estado !== null &&
				estado !== "" &&
				cidades_estados[item].nome === estado
			)
				return cidades_estados[item].cidades;
		}
	};

	const validateHelperText = (errors) => {
		setHelperText({
			nome_usuario: errors.nome_usuario,
			nome_organizacao: errors.nome_organizacao,
			cargo: errors.cargo,
			cidade: errors.cidade,
			estado: errors.estado,
			porte: errors.porte,
			email: errors.email,
			senha: errors.senha,
			confirmarSenha: errors.confirmarSenha,
			anoFundacao: errors.anoFundacao,
		});
	};

	const validateError = (errors) => {
		let aux = {
			nome_usuario: errors.nome_usuario ? true : false,
			nome_organizacao: errors.nome_organizacao ? true : false,
			cargo: errors.cargo ? true : false,
			cidade: errors.cidade ? true : false,
			estado: errors.estado ? true : false,
			porte: errors.porte ? true : false,
			email: errors.email ? true : false,
			senha: errors.senha ? true : false,
			confirmarSenha: errors.confirmarSenha ? true : false,
			anoFundacao: errors.anoFundacao ? true : false,
		};

		setError(aux);
	};

	const postUser = (user) => {
		postRegisterWithOrg(user)
			.then(function (responses) {

				setIsFetching(false);
			})
			.catch(function (errors) { 
				console.log(errors);

				validateHelperText(errors.response.data);
				validateError(errors.response.data);
			});
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		const user = {
			nome_usuario: nome_usuario,
			email: email,
			senha: senha,
			confirmarSenha: confirmarSenha,
			cargo: cargo,

			nome_organizacao: nome_organizacao,
			cidade: cidade,
			estado: estado,
			porte: porte,
			anoFundacao: anoFundacao,
		};

		postUser(user);
	};  

	return (
		<>
			<Form noValidate onSubmit={handleSubmit}>
				<h1>Usuário</h1>
				<div className="p-4">
					<Card variant="contained">
						<h4 className="m-2">Sobre a Organização</h4>
						<div className="my-2 col-sm-12 col-md-12 col-lg-12">
							<TextField
								fullWidth
								label="Nome da Organização"
								helperText={helperText.nome_organizacao}
								error={error.nome_organizacao}
								value={nome_organizacao}
								onChange={(e) => setOrganizacao(e.target.value)}
							/>
						</div>
						<div className="row">
							<div className="my-2 col-sm-12 col-md-6 col-lg-6">
								<Autocomplete
									fullWidth
									value={estado}
									onChange={(event, value) => {
										setEstado(value);
										setCidade("");
									}}
									options={cidades_estados.map(
										(item) => item.nome
									)}
									selectOnFocus
									clearOnBlur
									renderInput={(params) => (
										<TextField
											error={error.estado}
											helperText={helperText.estado}
											{...params}
											label="Estado"
										/>
									)}
								/>
							</div>

							<div className="my-2 col-sm-12 col-md-6 col-lg-6">
								<Autocomplete
									fullWidth
									value={cidade}
									onChange={(event, value) => {
										setCidade(value);
									}}
									options={
										selecionarCidades()
											? selecionarCidades()
											: []
									}
									selectOnFocus
									noOptionsText="Selecione um Estado"
									clearOnBlur
									renderInput={(params) => (
										<TextField
											error={error.cidade}
											helperText={helperText.cidade}
											{...params}
											label="Cidade"
										/>
									)}
								/>
							</div>
						</div>

						<div className="row">
							<div className="my-2 col-sm-12 col-md-6 col-lg-6">
								<FormControl fullWidth error={error.porte}>
									<InputLabel>Porte</InputLabel>
									<Select
										label="Porte"
										displayEmpty
										value={porte}
										onChange={(event) => {
											setPorte(event.target.value);
										}}
									>
										{porteData.map((item) => {
											return (
												<MenuItem
													key={item}
													value={item}
												>
													{item}
												</MenuItem>
											);
										})}
									</Select>

									<FormHelperText>
										{helperText.porte}
									</FormHelperText>
								</FormControl>
							</div>

							<div className="my-2 col-sm-12 col-md-6 col-lg-6">
								<TextField
									fullWidth
									label="Ano de Fundação"
									type="number"
									helperText={helperText.anoFundacao}
									error={error.anoFundacao}
									value={anoFundacao}
									onChange={(e) =>
										setAnoFundacao(e.target.value)
									}
								/>
							</div>
						</div>
					</Card>

					<Card className="mt-4" variant="contained">
						<h4 className="m-2">Dados Pessoais</h4>
						<div className="row">
							<div className="my-2 col-sm-12 col-md-6 col-lg-6">
								<TextField
									fullWidth
									label="Nome do Usuário"
									helperText={helperText.nome_usuario}
									error={error.nome_usuario}
									value={nome_usuario}
									onChange={(e) => setNome(e.target.value)}
								/>
							</div>

							<div className="my-2 col-sm-12 col-md-6 col-lg-6">
								<TextField
									fullWidth
									label="Cargo"
									helperText={helperText.cargo}
									error={error.cargo}
									value={cargo}
									onChange={(e) => setCargo(e.target.value)}
								/>
							</div>
						</div>
						<div className="row ">
							<div className="my-2 col-sm-12 col-md-6 col-lg-6">
								<TextField
									fullWidth
									label="E-mail Cadastrado"
									error={error.email}
									helperText={helperText.email}
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
							</div>
						</div>

						<div className="row">
							<div className="my-2 col-sm-12 col-md-6 col-lg-6">
								<TextField
									fullWidth
									label="Senha"
									type="password"
									helperText={helperText.senha}
									error={error.senha}
									value={senha}
									onChange={(e) => setSenha(e.target.value)}
								/>
							</div>
							<div className="my-2 col-sm-12 col-md-6 col-lg-6">
								<TextField
									fullWidth
									label="Confirmar Senha"
									type="password"
									helperText={helperText.confirmarSenha}
									error={error.confirmarSenha}
									value={confirmarSenha}
									onChange={(e) =>
										setConfirmarSenha(e.target.value)
									} 
								/>
							</div>
						</div>
					</Card>
				</div>

				<div className="d-flex justify-content-center">
					<Button type="submit" variant="outlined">
						Enviar
					</Button>
				</div>
			</Form>
		</>
	);
};

export default CadastroComOrg;
